import { take } from 'lib/array/arrayUtils'
import { setCookie } from 'lib/web/cookieUtils'
import { recentlyViewedMerchandiseCookieKey } from './getRecentlyViewedMerchandise'

const MAX_RECENTLY_VIEWED = 12
const COOKIE_TTL = 94608000 // 3 years in seconds

function setRecentlyViewedMerchandise(merchandiseIds: Array<string>): Promise<Array<string>> {
  const limitedIds = take(merchandiseIds, MAX_RECENTLY_VIEWED)
  setCookie(recentlyViewedMerchandiseCookieKey, limitedIds.join(','), COOKIE_TTL, '/', 'Lax', document.domain)
  return Promise.resolve(merchandiseIds)
}

export default setRecentlyViewedMerchandise
